import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ImpersonationState } from './impersonation.state';

export const IMPERSONATION_FEATURE_KEY = 'impersonation';

export const selectImpersonationState = createFeatureSelector<ImpersonationState>(IMPERSONATION_FEATURE_KEY);

export const selectIsImpersonating = createSelector(
  selectImpersonationState,
  (state: ImpersonationState) => state.isImpersonating
);

export const selectTargetUserId = createSelector(
  selectImpersonationState,
  (state: ImpersonationState) => state.targetUserId
);

export const selectOriginalUserId = createSelector(
  selectImpersonationState,
  (state: ImpersonationState) => state.originalUserId
);

export const selectIsConsultantImpersonation = createSelector(
  selectImpersonationState,
  (state: ImpersonationState) => state.isConsultantImpersonation
);

export const canAccessCapitalInsightDuringImpersonation = createSelector(
  selectImpersonationState,
  (state: ImpersonationState) => {
    if (!state.isImpersonating) {
      return true;
    }
    return state.accessScope?.includes('Capital Insight') === true;
  }
);

export const canAccessCapIQProDuringImpersonation = createSelector(
  selectImpersonationState,
  (state: ImpersonationState) => {
    if (!state.isImpersonating) {
      return true;
    }
    return state.accessScope?.includes('Cap IQ Pro') === true;
  }
);
